module.exports = __webpack_public_path__ + "static/media/parcel.bed573ab.svg";